
import s from './Home'
export default s
